<template>
  <MessageBubble :isMine="isMine" :message="message">
    <div class="custom-element-wrapper">
      <span class="group_create" v-if="payload.data === 'group_create'">{{
        text
      }}</span>
      <span class="text" v-else>{{ text }}</span>
      <a href="javascript:;" @click="initProductLink">{{ title }}</a>
    </div>
  </MessageBubble>
</template>

<script>
import MessageBubble from "../message-bubble";
import { Rate } from "element-ui";
import { ACTION } from "../../../utils/trtcCustomMessageMap";
import { formatDuration } from "../../../utils/formatDuration";

export default {
  name: "CustomElement",
  props: {
    payload: {
      type: Object,
      required: true,
    },
    message: {
      type: Object,
      required: true,
    },
    isMine: {
      type: Boolean,
    },
  },
  components: {
    MessageBubble,
    ElRate: Rate,
  },
  computed: {
    text() {
      return this.translateCustomMessage(this.payload);
    },
    rate() {
      return parseInt(this.payload.description);
    },
    title() {
      return this.translateCustomTitle(this.payload);
    },
  },
  methods: {
    isJsonStr(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (err) {
        return false;
      }
    },
    trimMsgContent(msg) {
      let string = "";
      if (msg.length > 0 && msg.length < 75) {
        string = msg;
      } else if (msg.length > 75 || msg.length == 75) {
        string = msg.slice(0, 75) + "……";
      }
      return string;
    },
    translateCustomMessage(payload) {
      // if (this.isJsonStr(payload.extension)) {
      //   console.log(JSON.parse(payload.extension))
      // } else {
      //   console.log('未能成功解析 extension 字段')
      // }

      // let videoPayload = {}
      // try{
      //   videoPayload = JSON.parse(payload.data)
      // } catch(e) {
      //   videoPayload = {}
      // }

      let action = payload.data;
      if (payload.data === "group_create") {
        return false;
        // return `${payload.extension}`
      }
      switch (action) {
        case ACTION.STEAMER_TICKET:
          return "[船票消息，请前往手机端查收]";
        case ACTION.TRANSFER_ACCOUNT:
          return "[转账消息，请前往手机端查收]";
        case ACTION.RED_ENVELOPE:
          return "[红包消息，请前往手机端查收]";
        case ACTION.ALBUM:
          return "[分享了相册]";
        case ACTION.ARTICLE:
          return "[分享了文章]";
        case ACTION.AUDIO:
          return "[分享了音频]";
        case ACTION.VIDEO:
          return "[分享了视频]";
        default:
          return "[自定义消息]";
      }
    },
    translateCustomTitle(payload) {
      let sharePayload = "";
      try {
        sharePayload = JSON.parse(payload.extension).title;
      } catch (e) {
        sharePayload = "";
      }
      return sharePayload;
    },
    initProductLink() {
      if (this.payload.hasOwnProperty("data")) {
        let action = this.payload.data;
        let productInfo = JSON.parse(this.payload.extension);
        if (productInfo.hasOwnProperty("id")) {
          var params = {
            feedID: productInfo.id,
          };
          switch (action) {
            case ACTION.ALBUM:
              params.feedType = 2;
              //this.$router.push({path:'detail',query:{feedID:productInfo.id, feedType: 2}});
              break;
            case ACTION.ARTICLE:
              params.feedType = 1;
              break;
            case ACTION.AUDIO:
              params.feedType = 3;
              break;
            case ACTION.VIDEO:
              params.feedType = 4;
              break;
          }
          let routerClanCard = this.$router.resolve({
            path: "detail",
            query: params,
          });
          window.open(routerClanCard.href, "_blank");
        }
      }
    },
  },
};
</script>

<style scoped>
.custom-element-wrapper .text {
  color: #ff8c1a;
}

.custom-element-wrapper a {
  margin-left: 8px;
  text-decoration: none;
  color: #428bca;
}

.text {
  font-weight: bold;
}

.title {
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 10px;
}

.survey {
  background-color: white;
  color: black;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.suggestion {
  padding-top: 10px;
  font-size: 14px;
}
</style>
